module.exports = __webpack_public_path__ + "img/home-lg.c6f387a1.jpg";